<template>
  <v-list-item-content style="border-bottom:1px solid grey;">
    <v-layout style="margin:0;" row>
      <v-flex xs8>
        <i @click="deleteOrigin" title="Delete origin" v-if="origin.suggested !== '1'" class="fal fa-trash"></i>
        <i @click="updateOrigin" title="Add suggestion" v-if="origin.suggested === '1'" class="fal fa-plus"></i>
        <span style="margin-left:15px;">{{ origin.origin }}</span>
      </v-flex>
      <v-flex xs4 style="text-align:right;">
        <v-chip v-if="origin.suggested === '1'" style="max-width:90px;">Suggested</v-chip>
      </v-flex>
    </v-layout>
  </v-list-item-content>
</template>

<script>
import { Apps } from "../../logic/Apps";
import { Notifications } from "../../notification";

export default {
  props: {
    origin: {
      type: Object,
      required: true,
    },
    app_id: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async deleteOrigin() {
      if (confirm("Do you really want to delete this origin?")) {
        var response = await Apps.removeOrigin(this.app_id, this.origin.id);
        if (response.status === 200) {
          Notifications.show("The origin has been removed.");
          this.$emit("onDeleted");
        } else {
          Notifications.show(response.message);
        }
      }
    },
    async updateOrigin() {
      if (confirm("Do you want to activate this origin?")) {
        var response = await Apps.updateOrigin(this.app_id, this.origin.id);
        if (response.status === 200) {
          Notifications.show("The origin has been updated.");
          this.$emit("onUpdated");
        } else {
          Notifications.show(response.message);
        }
      }
    }
  },
};
</script>

<style>
</style>